import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { Checkbox } from 'new/elements/Checkbox/Checkbox';
import { ConfirmDialog } from 'new/elements/ConfirmDialog/ConfirmDialog';

export interface TransferFlowOwnershipOptions {
  includeDataCredentials: boolean;
  includeReusableCode: boolean;
}

interface TransferFlowOwnershipDialogProps {
  open: boolean;
  newOwnerName: string;
  onClose: () => void;
  /** Reject to keep the dialog open, e.g. when either API call fails. */
  onConfirm: (options: TransferFlowOwnershipOptions) => Promise<void>;
}

export const TransferFlowOwnershipDialog = ({
  open,
  newOwnerName,
  onClose,
  onConfirm,
}: TransferFlowOwnershipDialogProps) => {
  const [includeDataCredentials, setIncludeDataCredentials] = useState(false);
  const [includeReusableCode, setIncludeReusableCode] = useState(false);

  // Each transfer starts unchecked, matching the API defaults.
  useEffect(() => {
    if (open) {
      setIncludeDataCredentials(false);
      setIncludeReusableCode(false);
    }
  }, [open]);

  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={() => onConfirm({ includeDataCredentials, includeReusableCode })}
      title="Transfer Ownership"
      variant="warning"
      confirmText="Transfer Ownership"
      message={
        <>
          <strong>{newOwnerName}</strong> will be granted Administrator access and then become the
          owner of this flow and its resources.
          <Box component="span" sx={{ display: 'flex', flexDirection: 'column', mt: 2 }}>
            <Checkbox
              label="Include data credentials"
              labelPlacement="end"
              checked={includeDataCredentials}
              onChange={(event) => setIncludeDataCredentials(event.target.checked)}
            />
            <Checkbox
              label="Include reusable code"
              labelPlacement="end"
              checked={includeReusableCode}
              onChange={(event) => setIncludeReusableCode(event.target.checked)}
            />
          </Box>
          <Box component="span" sx={{ display: 'block', mt: 1, fontSize: 'var(--font-size-sm)' }}>
            Data credentials and reusable code stay with their current owner unless included. If the
            new owner can&apos;t access them, the transfer fails.
          </Box>
        </>
      }
    />
  );
};

export default TransferFlowOwnershipDialog;
